enum DuplicateRunStatus {
  FINISHED = "finished",
  ONGOING = "ongoing",
}

export default DuplicateRunStatus;
